module.exports = __webpack_public_path__ + "static/media/W19-1193_Free_Root_Beer_Day_Desktop_2396x1473.c77d9e4d.jpg";